import { IUserLogins } from 'types';

export interface IUserRegistrationData {
  email: string;
  student_number: string;
  university: string;
  password: string;
  terms: boolean;
  marketing: boolean;
}

export enum AuthActionTypes {
  COGNITO_LOGIN_REQUEST = '@@auth/COGNITO_LOGIN_REQUEST',
  ACCEPT_TERMS = '@@user/ACCEPT_TERMS',
  ACCEPT_TERMS_SUCCESS = '@@user/ACCEPT_TERMS_SUCCESS',
  ACCEPT_TERMS_FAILURE = '@@user/ACCEPT_TERMS_FAILURE',
  COGNITO_LOGIN_SUCCESS = '@@auth/COGNITO_LOGIN_SUCCESS',
  COGNITO_LOGIN_FAILURE = '@@auth/COGNITO_LOGIN_FAILURE',
  COGNITO_REAUTH_REQUEST = '@@auth/COGNITO_REAUTH_REQUEST',
  COGNITO_REAUTH_SUCCESS = '@@auth/COGNITO_REAUTH_SUCCESS',
  COGNITO_REAUTH_FAILURE = '@@auth/COGNITO_REAUTH_FAILURE',
  TEST_LOGIN_SUCCESS = '@@auth/TEST_LOGIN_SUCCESS',
  LOGOUT_REQUEST = '@@auth/LOGOUT_REQUEST',
  COGNITO_LOGOUT_SUCCESS = '@@auth/COGNITO_LOGOUT_SUCCESS',
  SET_USERS_UNI = '@@auth/SET_USERS_UNI',
  SET_USERS_INTAKE = '@@auth/SET_USERS_INTAKE',
  TESTING = '@@auth/TESTING',
  GET_CURRENT_USER_REQUEST = '@@auth/GET_CURRENT_USER_REQUEST',
  GET_CURRENT_USER_SUCCESS = '@@auth/GET_CURRENT_USER_SUCCESS',
  GET_CURRENT_USER_FAILURE = '@@auth/GET_CURRENT_USER_FAILURE',
  GET_AUTH_AGENCY_REQUEST = '@@auth/GET_AUTH_AGENCY_REQUEST',
  GET_AUTH_AGENCY_SUCCESS = '@@auth/GET_AUTH_AGENCY_SUCCESS',
  GET_AUTH_AGENCY_FAILURE = '@@auth/GET_AUTH_AGENCY_FAILURE',
}

export enum UserRole {
  Admin = '[Admin]',
  UniAdmin = '[UniAdmin]',
  Uni = '[Uni]',
  UniSecure = '[UniSecure]',
  UniLite = '[UniLite]',
  Agent = '[Agent]',
  Enroly = '[Enroly]',
  AgencyAdmin = '[AgencyAdmin]',
  Partner = '[Partner]',
  ImmigrationProvider = '[ImmigrationProvider]',
  Unknown = '[Unknown]',
}

export const UNI_ROLES = ['[UniAdmin]', '[Uni]', '[UniSecure]', '[UniLite]'];
export const ENROLY_AGENT_ROLES = ['[Enroly]', '[Admin]'];
export const AGENT_ROLES = ['[Agent]', '[AgencyAdmin]'];
export const PARTNER_ROLES = ['[Partner]'];
export const IMMIGRATION_PROVIDER_ROLES = ['[ImmigrationProvider]'];

export interface AuthState {
  readonly student_number: string;
  readonly email: string;
  readonly uni: string;
  readonly pathway?: string;
  readonly intake: string;
  readonly institution: string;
  readonly role: UserRole;
  readonly groups: Array<string>;
  readonly terms: boolean;
  readonly marketing: boolean;
  readonly isPathway?: boolean;
  readonly pathwayAccess: 'Full' | 'Partial' | 'None';
  readonly validation_errors?: ReadonlyArray<{
    field: string;
    message: string;
  }>;
  readonly server_errors?: ReadonlyArray<string>;
  readonly isAuthenticating: boolean;
  readonly isLoggedIn?: boolean;
  readonly isTesting?: boolean;
  readonly isCodeSent: boolean;
  readonly userName?: string;
  readonly agencyId: string;
  readonly password: string;
  readonly resetPasswordRequestSent?: boolean;
  readonly resetPasswordRequestError?: string;
  readonly resetPasswordWithCodeSent?: boolean;
  readonly resetPasswordRequestWithCodeError?: string;
  readonly changePasswordRequestSent?: boolean;
  readonly changePasswordResponseError?: string;
  readonly currentUser: IUserLogins | null;
  readonly getSingleSignOnTokenError?: string;
  readonly wsConnected?: boolean;
  readonly authAgencyData: any | null;
  readonly authAgencyLoading: boolean;
  readonly authAgencyError: string | null;
}
